import styled from 'styled-components';

export const SimpleUrinaryIncontinenceLabel = styled.div`
  width: 210px;
  display: flex;
  align-self: center;
`;

export const InterventionLabel = styled.div`
  width: 300x;
  display: flex;
  align-self: center;
`;
